'use client';
import useRepositoryForkStatus from '@/hooks/useRepositoryForkStatus';
import { IRepository } from '@/types';
import Flash from '@/ui/Flash';
import * as Styled from './styled';
const ForkStatus: React.FC<{ repository: IRepository; children: React.ReactNode }> = ({ repository, children }) => {
  const { isLoading, data, error, isValidating, status } = useRepositoryForkStatus({ repository });

  const forkStatus = data?.fork_status;
  const isRunning = forkStatus && forkStatus.status !== 'complete';
  return isRunning ? (
    <Styled.ForkStatus>
      <Flash.Info>
        <b>Forking in progress...</b> try refreshing in a few seconds (longer if this is a large repository)
      </Flash.Info>
      <Styled.ForkingOxen />
    </Styled.ForkStatus>
  ) : (
    children
  );
};

export default ForkStatus;
